import Button from '@/components/Button'
import { Callout } from '@/components/Callout/Callout'

interface MirrorRestoreCalloutProps {
  sameVersion: boolean
  onRestore: () => void
  onDiscard: () => void
}

export const MirrorRestoreCallout = ({ sameVersion, onRestore, onDiscard }: MirrorRestoreCalloutProps) => (
  <Callout.Root>
    <Callout.Header>
      <Callout.Title>Restore unsaved edits from this browser?</Callout.Title>
      <Callout.Description>
        {sameVersion
          ? 'We found local edits that were never saved to the server.'
          : 'We found local edits from an older version of this document. Restoring replaces the current document with those edits.'}
      </Callout.Description>
    </Callout.Header>
    <Button title={sameVersion ? 'Restore' : 'Restore anyway'} type="dark" onClick={onRestore} />
    <Button title="Discard" type="light" onClick={onDiscard} />
  </Callout.Root>
)
